import { Grid, ListItem, ListItemText, Section } from '@cmg/design-system';
import { FormikAutocompleteField, parseSelectOptionToFormikValue } from '@cmg/design-system-formik';
import { xcSelectors } from '@cmg/e2e-selectors';
import React from 'react';

import { visibilityDescriptions, visibilityOptions } from '../../../constants';
import { defaultParseFormikValue } from './IssuerSubForm.model';

export type Props = Readonly<{
  disabled?: boolean;
}>;

const OfferingVisibilitySubForm: React.FC<Props> = ({ disabled }) => {
  return (
    <Section title="Offering Visibility">
      <Grid item md={3} sm={6} xs={12}>
        <FormikAutocompleteField
          data-testid={xcSelectors.offeringSetupBasicInfoVisibility.testId}
          label="Offering Visibility"
          placeholder="Choose Visibility..."
          name="isInternal"
          parseFormikValue={defaultParseFormikValue}
          parseToFormikValue={parseSelectOptionToFormikValue}
          disabled={disabled}
          fullWidth
          disableClearable
          options={visibilityOptions}
          renderOption={(props, option, _, ownerState) => {
            return (
              <ListItem {...props} disablePadding>
                <ListItemText
                  primary={ownerState.getOptionLabel(option)}
                  secondary={visibilityDescriptions[option.label]}
                />
              </ListItem>
            );
          }}
          required
        />
      </Grid>
    </Section>
  );
};

export default OfferingVisibilitySubForm;
